{
  "CommonWebUI_Eula": "Terms of Use and<br>Privacy Policy",
  "CommonWebUI_Filters": "Filters",
  "CommonWebUI_Logout": "Logout",
  "CommonWebUI_Profile": "Profile",
  "CommonWebUI_Help": "Help",
  "CommonWebUI_Settings": "Settings",
  "CommonWebUI_Satisfaction_Survey": "Satisfaction Survey",
  "CommonWebUI_Zoom": "Zoom",
  "CommonWebUI_Theme": "Theme",
  "CommonWebUI_Theme_Auto": "Auto",
  "CommonWebUI_Theme_Dark": "Dark",
  "CommonWebUI_Theme_Light": "Light",
  "CommonWebUI_ChipslistInput_Search_Add": "Add...",
  "CommonWebUI_ChipslistInput_Search_AddOrSelect": "Add or Select...",
  "CommonWebUI_DatePreset_Custom": "Custom",
  "CommonWebUI_DatePreset_Today": "Today",
  "CommonWebUI_InputSearch_Placeholder": "Search keywords...",
  "CommonWebUI_InputText_Placeholder": "Enter text here...",
  "CommonWebUI_LayoutOperationStatus_Error": "An error occurred. Please try again",
  "CommonWebUI_LayoutOperationStatus_No_Data": "No Data",
  "CommonWebUI_Navigation_Menu": "Menu",
  "CommonWebUI_RichTextBox_CustomClass_Highlight": "Highlight",
  "CommonWebUI_RichTextBox_CustomClass_Note": "Note",
  "CommonWebUI_RichTextBox_CustomClass_Paragraph": "Paragraph",
  "CommonWebUI_RichTextBox_CustomClass_Subtitle": "Subtitle",
  "CommonWebUI_RichTextBox_CustomClass_Title": "Title",
  "CommonWebUI_Select_Placeholder": "Please select...",
  "CommonWebUI_No_Selection": "No Selection",
  "CommonWebUI_Selection": "Selection",
  "CommonWebUI_Selections": "Selections",
  "CommonWebUI_Action_Save": "Save",
  "CommonWebUI_Action_Add": "Add",
  "CommonWebUI_Action_Clear": "Clear",
  "CommonWebUI_Action_Ok": "Ok",
  "CommonWebUI_Action_Done": "Done",
  "CommonWebUI_Action_Cancel": "Cancel",
  "CommonWebUI_Action_Submit": "Submit"
}